import { z } from 'zod';
/**
 * Schemas + DTOs für das Skill `floor-plan-editor` (Paket H, Issue #91).
 *
 * Konzept: Pro Projekt mehrere `MarkupScene`-Einträge — eine Szene entspricht
 * einem Konva-Stage-State (Layers, Shapes, Symbol-Positionen) auf einem optional
 * referenzierten Grundriss-PDF/-JPG. Frontend rendert via Konva, das Backend
 * speichert nur den serialisierten Stage-JSON-Blob + optionales PNG-Thumbnail
 * für Preview-Karten.
 *
 * sceneJson bleibt absichtlich strukturlos (Record<string, unknown>) — das
 * Editor-Format wird vom Frontend definiert und kann sich ohne Migration
 * weiterentwickeln. Validierung passiert clientseitig beim Laden.
 */
export const createMarkupSceneRequest = z
    .object({
    label: z.string().min(1).max(120),
    sourceDocumentId: z.number().int().positive().optional(),
    sceneJson: z.record(z.unknown()),
    pxPerMeter: z.number().positive().optional(),
})
    .strict();
export const updateMarkupSceneRequest = z
    .object({
    label: z.string().min(1).max(120).optional(),
    sceneJson: z.record(z.unknown()).optional(),
    pxPerMeter: z.number().positive().optional(),
})
    .strict();
